export default {
  methods: {
    isEmptyObject: (object) => Object.keys(object).length === 0,
  },
};
